import { AxiosRequestConfig } from 'axios';
import { FormAuthenticatedData } from 'backend';
import { ROOT_ELEMENT_ID } from '../models';

const REQUEST_HEADERS_BASE = {
  accept: 'application/json',
};

export type CustomHeader = {
  'X-From': Location['origin'];
  Authorization?: `Bearer ${FormAuthenticatedData['token']}`;
};

export const getAuthorizationHeaderProperty = (
  token: FormAuthenticatedData['token']
): CustomHeader['Authorization'] => `Bearer ${token}`;

export const getRequestHeaders = (
  customHeader: Partial<CustomHeader> = {}
): AxiosRequestConfig['headers'] => ({
  ...REQUEST_HEADERS_BASE,
  ...customHeader,
});

export const getApiUrlWithoutEndSlash = (): string => {
  const rootElement = document.getElementById(ROOT_ELEMENT_ID);
  const apiUrl = rootElement?.dataset.apiUrl;
  if (apiUrl == null) {
    return '';
  }
  if (apiUrl.endsWith('/')) {
    return apiUrl.slice(0, -1);
  }
  return apiUrl;
};
